let getPowerbookSectionTpl = function (data) {
  return `<section>
            <header class="search-title">
              <h2>파워북</h2>
            </header>

            <article class="search-article search-article--powerbook"></article>

            <footer class="search-more">
              <a href="${data.searchMoreBtnLink}">파워북 더보기 (${data.totalCount}건)</a>
            </footer>
          </section>`;
};

let getPowerbookListTpl = function (data) {
  const thumbnail = (data.thumbnail) ? `<div class="search-article__thumb"><p><img src="${data.thumbnail}"></p></div>` : '<div class="search-article__thumb none"></div>';

  return `<li>
            <a href="${data.link}">
              ${thumbnail}
              <div class="search-article__subject">${data.title}</div>
              <div class="search-article__desc">${data.description}</div>
            </a>
          </li>`;
};

export {
  getPowerbookSectionTpl,
  getPowerbookListTpl
};


// WEBPACK FOOTER //
// ./_src/js/search/powerbook2/tpl.js